export default __webpack_public_path__ + "static/media/ic_caret_right.8be177b1.svg";